import { render, staticRenderFns } from "./LimitedList.vue?vue&type=template&id=030a2489&"
import script from "./LimitedList.vue?vue&type=script&lang=js&"
export * from "./LimitedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports